<template>
  <div class="cs-icon" :class="{ [containerSize]: true }">
    <i :class="{ [name]: true }" :style="{ backgroundImage: svgIcon }" ></i>
  </div>
</template>

<script>
import { inArray } from 'lib/component/validators';

import { getIcon } from './icon';

const DEFAULT_COLOR = '#fff';

export default {
  name: 'CSIcon',
  props: {
    name: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default() {
        return DEFAULT_COLOR;
      },
    },
    containerSize: {
      type: String,
      validator: inArray(['extra-small', 'small', 'medium', 'extra-medium', 'large']),
      default() {
        return 'small';
      },
    },
  },
  computed: {
    svgIcon() {
      return getIcon(this.name, this.color);
    },
  },
};
</script>

<style lang="sass" scoped>
  .cs-icon
    position: relative

    &.extra-small
      width: 16px
      height: 16px

    &.small
      width: 20px
      height: 20px

    &.medium
      width: 30px
      height: 30px

    &.extra-medium
      width: 24px
      height: 24px

    &.large
      width: 40px
      height: 40px

    i
      width: 100%
      height: 100%
      position: absolute
      top: 0
      left: 0
      background-repeat: no-repeat
      background-position: center
      background-size: contain
</style>
